import { Component } from '@theme/component';

class LazyZoomDialog extends Component {
  #runtime;
  #runtimePromise;

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#runtime?.destroy();
    this.#runtime = undefined;
    this.#runtimePromise = undefined;
  }

  async #getRuntime() {
    if (this.#runtime) return this.#runtime;

    if (!this.#runtimePromise) {
      this.#runtimePromise = import('./zoom-dialog-runtime.js').then(({ ZoomDialogRuntime }) => {
        if (!this.isConnected) return undefined;
        this.#runtime = new ZoomDialogRuntime(this);
        return this.#runtime;
      });
    }

    return this.#runtimePromise;
  }

  async open(index, event) {
    event?.preventDefault();
    const runtime = await this.#getRuntime();
    return runtime?.open(index, event);
  }

  close() {
    return this.#runtime?.close();
  }

  loadHighResolutionImage(mediaContainer) {
    return this.#runtime?.loadHighResolutionImage(mediaContainer) ?? false;
  }

  get isBuilt() {
    return this.#runtime?.isBuilt ?? false;
  }

  get media() {
    return this.#runtime?.media ?? [];
  }
}

if (!customElements.get('zoom-dialog')) {
  customElements.define('zoom-dialog', LazyZoomDialog);
}
